import { IGetPackagingProcessing } from './types'

// functionalUnit dropped vs food's getProcessingVars (helpers.ts) per FE spec §2.1/OQ3 —
// packaging's FunctionalUnit column is a static literal from the view ("1 kg of output
// component"), not a GraphQL enum, so no __type alias / enum filter entry for it.
export const getPackagingProcessingVars: IGetPackagingProcessing = {
  secondaryDataReferenceSourceType: {
    in: [
      'PrimaryDataFromIndustrySenseChecked',
      'PrimaryDataMeasurementsTakenByMondra',
      'PeerReviewedPublishedLiterature',
      'PublishedBook',
      'IndustryPublishedReport',
      'Ecoinvent',
      'AgriFootPrint',
      'GovernmentFundedOrganizationReport',
      'NonGovernmentalFundedOrganizationReport',
      'Patent',
      'CompanyWebsite',
      'BlogWebsiteForum',
      'OpenSourceWebsite',
      'UndocumentedEstimate',
    ],
  },
  state: {
    in: ['Unpublished', 'Published'],
  },
}
